/*
 * Copyright (c) 2025 Amazon.com, Inc. or its affiliates. All rights reserved.
 *
 * PROPRIETARY/CONFIDENTIAL. USE IS SUBJECT TO LICENSE TERMS.
 */

import {useQueryState} from 'nuqs';
import {MbmProvider} from '@amzn/react-arb-tools';
import {LocalizationContextBuilder} from '@amzn/arb-tools';
import {DEFAULT_LOCALE} from '../constants';
import arbManifest from 'translations/arbManifest';
import {resolveBundleUrlWithFallbacks} from '../helpers';
import {PhotoForm} from 'src/photoForm/PhotoForm';
import {UploadClient} from 'src/api/UploadClient';
import {UploadClientProvider} from 'src/api/UploadClientProvider';

export const App = () => {
  const [locale] = useQueryState('locale', {defaultValue: DEFAULT_LOCALE});

  const mbmOptions = {
    arbManifest,
    defaultLocalizationContext: new LocalizationContextBuilder()
      .withLocale(locale)
      .withDefaultLocale(DEFAULT_LOCALE)
      .build(),
    resolveBundleUrl: (
      resourcePackPath: string | undefined,
      locale: string,
      bundle: string,
    ) => resolveBundleUrlWithFallbacks(resourcePackPath, locale, bundle),
  };

  return (
    <UploadClientProvider value={new UploadClient()}>
      <MbmProvider {...mbmOptions}>
        <PhotoForm />
      </MbmProvider>
    </UploadClientProvider>
  );
};
